
import './css/style.css';
import Application from './components/Application';
function App() {

   return (
    <div className="App">


        <Application/>


    </div>
  );
}

export default App;
